import React from 'react';
import Button from 'carbon-components-react/lib/components/Button';
import { InlineNotification } from 'carbon-components-react/lib/components/Notification/Notification';

type Props = {
  onClose: () => void;
  onSetup: () => void;
};

const ResponseCollationNotification: React.FC<Props> = ({
  onClose,
  onSetup
}) => {
  return (
    <div className="rc-notification">
      <InlineNotification
        className="rc-notification--content"
        kind="info"
        lowContrast
        notificationType="toast"
        onCloseButtonClick={onClose}
        subtitle={
          <div className="rc-notification--content-subtitle">
            <span className="text">
              You can choose when to be notified of enquiry responses. Change
              this option at any time in the actions menu.
            </span>

            <div className="button-container">
              <Button
                kind="tertiary"
                size="sm"
                className="left"
                onClick={onSetup}
              >
                Set up
              </Button>
              <Button kind="ghost" size="sm" onClick={onClose}>
                Not now
              </Button>
            </div>
          </div>
        }
        title="Have you set up your notification options?"
      />
    </div>
  );
};

export default ResponseCollationNotification;
